import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@mui/styles'
import { Paper } from 'components';
const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  }
});

const Portlet = props => {
  const { classes, className, children, noPaper = false, ...rest } = props;

  let { outlined } = props;

  const rootClassName = classNames(classes.root, className);

  outlined = (typeof outlined === 'undefined' ? true : outlined);
  return (
    !noPaper ? <Paper
      {...rest}
      className={rootClassName}
      elevation={0}
      outlined={outlined}
      squared={false}
    >
      {children}
    </Paper> : <div {...rest} className={rootClassName}>{children}</div>
  );
};

Portlet.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  outlined: PropTypes.bool,
  noPaper: PropTypes.bool,
};

export default withStyles(styles)(Portlet);
